const getPageType = () => {
    const body = document.querySelector('body');
    return body.getAttribute('data-pt');
};

export default getPageType;
